import React from 'react'
import Base from './Base'

export default props => (
  <Base {...props}>
    <path d='M41.1,6.6H36.5V4.3a2.3,2.3,0,0,0-4.6,0V6.6H18.1V4.3A2.17,2.17,0,0,0,15.8,2a2.17,2.17,0,0,0-2.3,2.3V6.6H8.9A6.78,6.78,0,0,0,2,13.5v9.2H2V41.1A6.78,6.78,0,0,0,8.9,48H41.1A6.78,6.78,0,0,0,48,41.1V22.7h0V13.5A6.78,6.78,0,0,0,41.1,6.6ZM8.9,11.2h4.6v2.3a2.17,2.17,0,0,0,2.3,2.3,2.17,2.17,0,0,0,2.3-2.3V11.2H31.9v2.3a2.3,2.3,0,1,0,4.6,0V11.2h4.6a2.17,2.17,0,0,1,2.3,2.3v6.9H6.6V13.5A2.17,2.17,0,0,1,8.9,11.2ZM41.1,43.4H8.9a2.17,2.17,0,0,1-2.3-2.3V25H43.4V41.1A2.17,2.17,0,0,1,41.1,43.4Z' />
  </Base>
)
